import { useState } from "react";
import type { Drama } from "@/types";

interface EpisodeListProps {
  drama: Drama;
}

export default function EpisodeList({ drama }: EpisodeListProps) {
  const [selected, setSelected] = useState(1);
  const episodes = Array.from({ length: drama.episodeCount }, (_, i) => i + 1);

  return (
    <section>
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-list-check-2 text-lg"></i>
        </span>
        <h2 className="font-heading text-xl font-bold text-foreground-950">剧集目录</h2>
        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
          全 {drama.episodeCount} 集
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[1fr_320px]">
        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <div className="max-h-[360px] overflow-y-auto pr-1 lg:max-h-[420px]">
            <div className="grid grid-cols-4 gap-2 sm:grid-cols-6 lg:grid-cols-8">
              {episodes.map((no) => (
                <button
                  key={no}
                  type="button"
                  onClick={() => setSelected(no)}
                  className={`flex h-10 items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
                    selected === no
                      ? "bg-primary-600 text-background-50"
                      : "bg-background-200/70 text-foreground-700 hover:bg-accent-100 hover:text-accent-800"
                  }`}
                >
                  {no}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-5">
          <p className="font-label text-[11px] tracking-[0.2em] text-accent-600">NOW VIEWING</p>
          <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
            第 {selected} 集
          </h3>
          <div className="mt-4 flex flex-col gap-3 text-xs text-foreground-600">
            <span className="flex items-center gap-2">
              <i className="ri-time-line text-accent-600"></i>
              更新时间：{drama.updatedAt}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-timer-line text-accent-600"></i>
              单集时长：约 45 分钟
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            本集围绕{drama.title}的核心线索展开，人物关系进一步收紧。沈知微在看似平静的日常里察觉到了新的异常，
            而这一次，她决定不再逃避，主动去追问那些被刻意隐藏的答案。
          </p>
          <p className="mt-4 text-xs text-foreground-400">
            注：剧集目录为内容展示演示，不提供实际播放与下载功能。
          </p>
        </div>
      </div>
    </section>
  );
}